// Configuração da aplicação baseada no app-config.json
interface ApiConfig {
  baseUrl: string;
}

interface AzureAdConfig {
  clientId: string;
  tenantId: string;
  redirectUri: string;
  scopes: string[];
}

interface AuthConfig {
  azureAd: AzureAdConfig;
}

interface UiConfig {
  itemsPerPage: number;
  maxImageSize: number;
  allowedImageTypes: string[];
}

type Environment = 'development' | 'homologation' | 'production';

interface AppConfig {
  environment?: Environment;
  api: ApiConfig;
  auth: AuthConfig;
  ui: UiConfig;
}

let config: AppConfig | null = null;

/**
 * Carrega a configuração do arquivo app-config.json
 * Implementa cache para evitar múltiplas requisições
 */
export const loadConfig = async (): Promise<AppConfig> => {
  if (config) {
    return config;
  }

  try {
    const response = await fetch('/config/app-config.json', { cache: 'no-store' });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    config = await response.json();
    console.log('✅ Config loaded from server:', {
      baseUrl: config!.api.baseUrl,
      clientId: config!.auth.azureAd.clientId,
      redirectUri: config!.auth.azureAd.redirectUri
    });
    return config as AppConfig;
  } catch (error) {
    console.error('Failed to load config:', error);
    
    // Fallback para desenvolvimento
    config = {
      api: {
        baseUrl: 'http://localhost:8080/api/v1'
      },
      auth: {
        azureAd: {
          clientId: '907b462e-1410-4af9-97a7-1a98ea466e53',
          tenantId: '134a291a-2d6a-466d-9ef8-28480515db86',
          redirectUri: 'http://localhost:5173/auth/callback',
          scopes: ['api://9a2665a5-676c-4c64-a92e-d994847a0170/access_as_user']
        }
      },
      ui: {
        itemsPerPage: 20,
        maxImageSize: 5242880,
        allowedImageTypes: ['image/jpeg', 'image/png', 'image/webp']
      }
    };
    
    return config as AppConfig;
  }
};

/**
 * Retorna a configuração carregada (síncronamente)
 * Use apenas após chamar loadConfig()
 */
export const getConfig = (): AppConfig => {
  if (!config) {
    throw new Error('Config not loaded. Call loadConfig() first.');
  }
  return config as AppConfig;
};

export type { AppConfig, ApiConfig, AuthConfig, AzureAdConfig, UiConfig, Environment };